import { gql } from "@apollo/client";

export const GET_ALL_REPORTE_VENTA = gql`
query GetAllReporteVenta {
    allReporteVenta{
            idReporteVenta,
            descripcion
      }
}`;